module.exports = __webpack_public_path__ + "b53190aac57b904d692d401707ea8bbc.pdf";